<section class="spacer-pt-space spacer-pb-space overflow-hidden">
    <div class="container">
        <div class="intro-text flex items-center justify-between">
            <h2 class="heading-primary-8xl">What Sets <u>Us Apart</u></h2>
            <div class="hidden md:flex gap-5">
                <button class="swiper-button-prev disable" id="slider-prev" type="button" title="Previous"
                    (click)="handler_sliderNext($event,'prev')"></button>
                <button class="swiper-button-next" id="slider-next" type="button" title="Next"
                    (click)="handler_sliderNext($event,'next')"></button>
            </div>
        </div>
        <div class="carouselCard-wrap" id="js-carouselCard-wrap">
            @for (item of cardData; track $index; let i = $index) {
            <div class="carouselCard" [id]="'slide-'+i" (click)="handler_slider($event)" [class.active]="i == 0">
                <img [ngSrc]="assetsCDNUrl+item.imgUrl" alt="Slider" width="800" height="300" class="carouselCard-img">
                <p class="carouselCard-verticalText hidden md:block">{{item.subTitle}}</p>
                <div class="carouselCard-content">
                    <div class="carouselCard-animateText">
                        <p class="carouselCard-title">{{item.titletext}}</p>
                        <p class="carouselCard-subText ">{{item.description}}</p>
                    </div>
                    <p class="carouselCard-verticalText md:hidden">{{item.subTitle}}</p>
                </div>
            </div>
            }

        </div>
    </div>
</section>